<!--  error-component error-label -->
@if (errorMessages?.length > 0 && isVisible) {
  <div class="sh-custom-form-error" [ngClass]="customClass">
    @for (errorMessage of errorMessages; track errorMessage) {
      <ul class="sh-custom-form-error__list" [ngClass]="listClass">
        <li class="sh-custom-form-error__list-item" [ngClass]="listItemClass">
          &hellip; {{ errorMessage }}
        </li>
      </ul>
    }
  </div>
}
